var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "#5E639B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 11.9286V9.07143L10.7143 6.57143V4.78571H15.7143V0.5H9.28571V6.57143L2.85714 9.07143V11.9286H0V20.5H7.14286V16.2143H12.8571V20.5H20V11.9286H17.1429ZM10 11.9286C9.21143 11.9286 8.57143 11.2886 8.57143 10.5C8.57143 9.71143 9.21143 9.07143 10 9.07143C10.7886 9.07143 11.4286 9.71143 11.4286 10.5C11.4286 11.2886 10.7886 11.9286 10 11.9286Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/SchoolIcon.0572d90a8fc7473cd4e84d2b26958f64.svg";
export { ForwardRef as ReactComponent };